<!-- 环状 -->
<template>
  <div class="h-ring">
    <div class="ring-relative">
      <ve-ring
        class="ring-box"
        :data="chartData"
        :settings="chartSettings"
        height="112px"
        width="112px"
        :tooltip="tooltip"
        :extend="chartExtend"
      ></ve-ring>
      <span class="desc">{{percentage}}</span>
    </div>
    <p class="title">{{text}}</p>
  </div>
</template>

<script>
export default {
  data () {
    this.chartSettings = {
      dimension: 'name',
      metrics: 'value',
      label: {
        normal: {
          show: false
        }
      },
      radius: [
        '25', '40'
      ],
      offsetY: 56
    }
    return {
      tooltip: {
        trigger: 'none'
      },
      chartExtend: {
        legend: {
          show: false
        },
        color: ['#44F0FF', '#19355A']
      }
    }
  },
  props: {
    text: {
      type: String,
      required: true
    },
    chartData: {
      type: Object,
      required: true
    },
    percentage: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang='stylus' scoped>
.h-ring
  display flex
  flex-direction column
  justify-content flex-start
  align-items center
  .ring-relative
    position relative
    height 112px
    width 112px
    .desc
      position absolute
      top 0
      right 0
      bottom 0
      left 0
      margin auto
      font-size 14px
      height 14px
      line-height 14px
      color #fff
      text-align center
  .title
    font-size 14px
    color #fff
    height 14px
    line-height 14px
</style>



// WEBPACK FOOTER //
// src/components/common/hRing.vue